import { action, observable, runInAction, toJS } from "mobx";
import { FormStore, Dialog } from "@weapp/ui"
import { getLabel } from "@weapp/utils";
import * as API from "../../../../api/login";
import { encryptRsa } from "../../../../utils";

const { message } = Dialog;

export class ResetPassStore {

  @observable formStore = new FormStore();
  @observable loading = false;

  @observable data = {
    account: "",
    password: "",
    passwordCheck: "",
  }

  @action
  setAccount = (account: string) => {
    this.data.account = account;
  }

  @action
  setOldPassword = (oldPassword: string) => {
    this.data.passwordCheck = oldPassword;
  }

  checkValid = () => {
    const data = this.formStore.getFormDatas();
    if (!data.newPassword) {
      message({ type: "info", content: getLabel('93541', '请输入新密码') })
      return false;
    }
    if (!data.newPasswordAgain) {
      message({ type: "info", content: getLabel('154650', '请再次输入新密码') })
      return false;
    }
    if (data.newPasswordAgain !== data.newPassword) {
      message({ type: "info", content: getLabel('93526', '两次密码不一致') })
      return false;
    }
    // if ((data.newPassword || "").length < 6 || (data.newPasswordAgain || "").length < 6) {
    //   message({ type: "info", content: getLabel('65392', '请输入至少6位密码') })
    //   return false;
    // }
    return true;
  }

  @action
  updateData = (data: any) => {
    this.data = { ...this.data, ...data };
  }

  @action
  submit = (callback?: Function) => {
    if (this.checkValid()) {
      this.loading = true;
      API.resetPass(this.data).then(({ status, msg, data }) => {
        runInAction(() => {
          this.loading = false;
          if (status) {
            callback && callback();
          } else {
            message({ type: "error", content: msg || data?.errorMsg?.msg })
          }
        })
      }).catch(() => {
        runInAction(() => {
          this.loading = false;
        })
      })
    }
  }
}